// this seriously needs a better name

import React from 'react';

// expects an object such as: {jobcontext: 'id'}
const LocContextContent: {
  [key: string]: string
} = {
}

const LocContext = React.createContext(LocContextContent);

export default LocContext;
